<template>
    <div class="video">
        <!-- <video
            width="100%"
            class="one-background-video video_bg"
            muted="muted"
            data-autoplay
            autoplay
            loop
        >
            <source src="../../assets/media/top.mp4" type="video/mp4" />
        </video> -->
        <img src="../../assets/media/video.jpg" alt="">
    </div>
</template>

<script>
export default {
    name: "Video"
};
</script>

<style lang="scss" scoped>
.video_bg {
    max-width: 100%;
    background: url(".././../assets/media/video_dim.jpg") no-repeat;
    background-size: 100% 100%;
}
</style>
